export default __webpack_public_path__ + "static/media/modal_exit.2692eb6b.svg";